import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Select = React.forwardRef(({ className = '', children, ...props }, ref) => {
    return (_jsx("select", { ref: ref, className: `flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${className}`, ...props, children: children }));
});
Select.displayName = 'Select';
